"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.validateConfiguration = exports.switchSelectedAmount = exports.switchOptionsBasic = exports.switchOptions = exports.skipNextAutoResolve = exports.setStockInformationOption = exports.setSelectedVariantIdentifier = exports.setSelectedCalculation = exports.setSelectedAmounts = exports.setSelectedAmount = exports.setOptionclassificationChecked = exports.setOptionInputText = exports.setLoadIdentifier = exports.setLoadCode = exports.setDefaultSelectedVariantIdentifier = exports.setCustomTitle = exports.setConflictingSwitchoptionData = exports.setComment = exports.setCalculationErrorsResolved = exports.setCalculationEnabled = exports.setCalculationAutoResolveEnabled = exports.selectOptionclassification = exports.selectOption = exports.selectMultipleOptions = exports.saveConfiguration = exports.saveBulkNames = exports.resolveConflicts = exports.resetOptionInputTexts = exports.receiveValidation = exports.receiveSwitchoptionsresult = exports.receiveSavedConfiguration = exports.receiveOptions = exports.receiveOptionDetails = exports.receiveInspirations = exports.receiveDesignerData = exports.receiveConfigurationVariants = exports.receiveConfiguration = exports.receiveCodesnippets = exports.receiveClientData = exports.receiveCalculation = exports.loadInitialOptionclassification = exports.loadDesignerData = exports.loadConfiguration = exports.invalidateCalculation = exports.inspectValidationResults = exports.inspectCheckResults = exports.fetchOptions = exports.fetchOptionDetails = exports.fetchInspirations = exports.fetchInitialConfiguration = exports.fetchConfigurationVariants = exports.fetchConfigurationForDesignerProductPreview = exports.fetchConfigurationByCodeAsync = exports.fetchConfigurationByCode = exports.fetchConfiguration = exports.fetchCodesnippets = exports.fetchClientData = exports.doCalculation = exports.deleteSelectedAmounts = exports.deleteSelectedAmount = exports.deleteMissingVariants = exports.clearOptionDetails = exports.clearBulkNames = exports.applyVariantAmountPreSelection = exports.applyOptionInputText = exports.SWITCH_SELECTED_AMOUNT = exports.SET_STOCK_INFORMATION_OPTION = exports.SET_SELECTED_VARIANT_IDENTIFIER = exports.SET_SELECTED_CALCULATION = exports.SET_SELECTED_AMOUNTS = exports.SET_SELECTED_AMOUNT = exports.SET_OPTION_INPUT_TEXT = exports.SET_OPTIONCLASSIFICATION_CHECKED = exports.SET_LOAD_IDENTIFIER = exports.SET_LOAD_CODE = exports.SET_CUSTOM_TITLE = exports.SET_CONFLICTING_SWITCHOPTION_DATA = exports.SET_COMMENT = exports.SET_CALCULATION_ERRORS_RESOLVED = exports.SET_CALCULATION_ENABLED = exports.SET_CALCULATION_AUTO_RESOLVE_ENABLED = exports.SELECT_OPTIONCLASSIFICATION = exports.SAVE_BULKNAMES = exports.RESET_OPTION_INPUT_TEXTS = exports.RECEIVE_VALIDATION = exports.RECEIVE_SWITCHOPTIONSRESULT = exports.RECEIVE_SAVEDCONFIGURATION = exports.RECEIVE_OPTIONS = exports.RECEIVE_OPTIONDETAILS = exports.RECEIVE_INSPIRATIONS = exports.RECEIVE_DESIGNER_DATA = exports.RECEIVE_CONFIGURATIONVARIANTS = exports.RECEIVE_CONFIGURATION = exports.RECEIVE_CODESNIPPETS = exports.RECEIVE_CLIENT_DATA = exports.RECEIVE_CALCULATION = exports.INVALIDATE_CALCULATION = exports.DELETE_SELECTED_AMOUNTS = exports.DELETE_SELECTED_AMOUNT = exports.CLEAR_BULKNAMES = void 0;
exports.viewOptionDetails = void 0;
var apiActions = _interopRequireWildcard(require("../Actions"));
var _first = _interopRequireDefault(require("lodash/first"));
var _isObject = _interopRequireDefault(require("lodash/isObject"));
var _get = _interopRequireDefault(require("lodash/get"));
var _isArray = _interopRequireDefault(require("lodash/isArray"));
var _flatten = _interopRequireDefault(require("lodash/flatten"));
var _find = _interopRequireDefault(require("lodash/find"));
var _uniq = _interopRequireDefault(require("lodash/uniq"));
var _i18n = require("../../../Framework/i18n");
var _Api = _interopRequireDefault(require("../../../Framework/Api"));
var _createActionWithGlobalState = require("../../../Utils/Redux/createActionWithGlobalState");
var _configuration = require("../../configuration");
var _ServiceLocator = require("../../ServiceLocator");
var _Actions2 = require("../UI/Actions");
var _Actions3 = require("../../Reducers/Fonts/Actions");
var _Actions4 = require("../../Reducers/ImageGallery/Actions");
var _Selectors = require("./Selectors");
var _Selectors2 = require("../ConfigurationMode/Selectors");
var _Constant = require("../../Constant");
var _Selectors3 = require("../Fonts/Selectors");
var _Actions5 = require("../Fonts/Actions");
var _Modifiers = require("./Modifiers");
var _Actions6 = require("../DesignData/Actions");
var _Transformers = require("../DesignArea/Transformers");
var _Reducer = require("../DesignData/Reducer");
var _Actions7 = require("../ConfigurationMode/Actions");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it["return"] != null) it["return"](); } finally { if (didErr) throw err; } } }; }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return e; }; var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function (t, e, r) { t[e] = r.value; }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag"; function define(t, e, r) { return Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }), t[e]; } try { define({}, ""); } catch (t) { define = function define(t, e, r) { return t[e] = r; }; } function wrap(t, e, r, n) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []); return o(a, "_invoke", { value: makeInvokeMethod(t, r, c) }), a; } function tryCatch(t, e, r) { try { return { type: "normal", arg: t.call(e, r) }; } catch (t) { return { type: "throw", arg: t }; } } e.wrap = wrap; var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var p = {}; define(p, a, function () { return this; }); var d = Object.getPrototypeOf, v = d && d(d(values([]))); v && v !== r && n.call(v, a) && (p = v); var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p); function defineIteratorMethods(t) { ["next", "throw", "return"].forEach(function (e) { define(t, e, function (t) { return this._invoke(e, t); }); }); } function AsyncIterator(t, e) { function invoke(r, o, i, a) { var c = tryCatch(t[r], t, o); if ("throw" !== c.type) { var u = c.arg, h = u.value; return h && "object" == _typeof(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) { invoke("next", t, i, a); }, function (t) { invoke("throw", t, i, a); }) : e.resolve(h).then(function (t) { u.value = t, i(u); }, function (t) { return invoke("throw", t, i, a); }); } a(c.arg); } var r; o(this, "_invoke", { value: function value(t, n) { function callInvokeWithMethodAndArg() { return new e(function (e, r) { invoke(t, n, e, r); }); } return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(e, r, n) { var o = h; return function (i, a) { if (o === f) throw new Error("Generator is already running"); if (o === s) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var c = n.delegate; if (c) { var u = maybeInvokeDelegate(c, n); if (u) { if (u === y) continue; return u; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (o === h) throw o = s, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = f; var p = tryCatch(e, r, n); if ("normal" === p.type) { if (o = n.done ? s : l, p.arg === y) continue; return { value: p.arg, done: n.done }; } "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg); } }; } function maybeInvokeDelegate(e, r) { var n = r.method, o = e.iterator[n]; if (o === t) return r.delegate = null, "throw" === n && e.iterator["return"] && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y; var i = tryCatch(o, e.iterator, r.arg); if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y; var a = i.arg; return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y); } function pushTryEntry(t) { var e = { tryLoc: t[0] }; 1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e); } function resetTryEntry(t) { var e = t.completion || {}; e.type = "normal", delete e.arg, t.completion = e; } function Context(t) { this.tryEntries = [{ tryLoc: "root" }], t.forEach(pushTryEntry, this), this.reset(!0); } function values(e) { if (e || "" === e) { var r = e[a]; if (r) return r.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) { var o = -1, i = function next() { for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next; return next.value = t, next.done = !0, next; }; return i.next = i; } } throw new TypeError(_typeof(e) + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), o(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) { var e = "function" == typeof t && t.constructor; return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name)); }, e.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t; }, e.awrap = function (t) { return { __await: t }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () { return this; }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(wrap(t, r, n, o), i); return e.isGeneratorFunction(r) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () { return this; }), define(g, "toString", function () { return "[object Generator]"; }), e.keys = function (t) { var e = Object(t), r = []; for (var n in e) r.push(n); return r.reverse(), function next() { for (; r.length;) { var t = r.pop(); if (t in e) return next.value = t, next.done = !1, next; } return next.done = !0, next; }; }, e.values = values, Context.prototype = { constructor: Context, reset: function reset(e) { if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0].completion; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(e) { if (this.done) throw e; var r = this; function handle(n, o) { return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o; } for (var o = this.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i.completion; if ("root" === i.tryLoc) return handle("end"); if (i.tryLoc <= this.prev) { var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc"); if (c && u) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } else if (c) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); } else { if (!u) throw new Error("try statement without catch or finally"); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } } } }, abrupt: function abrupt(t, e) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var o = this.tryEntries[r]; if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) { var i = o; break; } } i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null); var a = i ? i.completion : {}; return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a); }, complete: function complete(t, e) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y; }, finish: function finish(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y; } }, "catch": function _catch(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.tryLoc === t) { var n = r.completion; if ("throw" === n.type) { var o = n.arg; resetTryEntry(r); } return o; } } throw new Error("illegal catch attempt"); }, delegateYield: function delegateYield(e, r, n) { return this.delegate = { iterator: values(e), resultName: r, nextLoc: n }, "next" === this.method && (this.arg = t), y; } }, e; }
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }
function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }
var RECEIVE_CONFIGURATION = exports.RECEIVE_CONFIGURATION = 'RECEIVE_CONFIGURATION';
var RECEIVE_DESIGNER_DATA = exports.RECEIVE_DESIGNER_DATA = 'RECEIVE_DESIGNER_DATA';
var SELECT_OPTIONCLASSIFICATION = exports.SELECT_OPTIONCLASSIFICATION = 'SELECT_OPTIONCLASSIFICATION';
var RECEIVE_OPTIONS = exports.RECEIVE_OPTIONS = 'RECEIVE_OPTIONS';
var RECEIVE_SWITCHOPTIONSRESULT = exports.RECEIVE_SWITCHOPTIONSRESULT = 'RECEIVE_SWITCHOPTIONSRESULT';
var RECEIVE_CALCULATION = exports.RECEIVE_CALCULATION = 'RECEIVE_CALCULATION';
var INVALIDATE_CALCULATION = exports.INVALIDATE_CALCULATION = 'INVALIDATE_CALCULATION';
var RECEIVE_OPTIONDETAILS = exports.RECEIVE_OPTIONDETAILS = 'RECEIVE_OPTIONDETAILS';
var RECEIVE_SAVEDCONFIGURATION = exports.RECEIVE_SAVEDCONFIGURATION = 'RECEIVE_SAVEDCONFIGURATION';
var RECEIVE_VALIDATION = exports.RECEIVE_VALIDATION = 'RECEIVE_VALIDATION';
var RECEIVE_CONFIGURATIONVARIANTS = exports.RECEIVE_CONFIGURATIONVARIANTS = 'RECEIVE_CONFIGURATIONVARIANTS';
var RECEIVE_CODESNIPPETS = exports.RECEIVE_CODESNIPPETS = 'RECEIVE_CODESNIPPETS';
var RECEIVE_CLIENT_DATA = exports.RECEIVE_CLIENT_DATA = 'RECEIVE_CLIENT_DATA';
var RECEIVE_INSPIRATIONS = exports.RECEIVE_INSPIRATIONS = 'RECEIVE_INSPIRATIONS';
var SET_CUSTOM_TITLE = exports.SET_CUSTOM_TITLE = 'SET_CUSTOM_TITLE';
var SET_LOAD_CODE = exports.SET_LOAD_CODE = 'SET_LOAD_CODE';
var SET_LOAD_IDENTIFIER = exports.SET_LOAD_IDENTIFIER = 'SET_LOAD_IDENTIFIER';
var SET_STOCK_INFORMATION_OPTION = exports.SET_STOCK_INFORMATION_OPTION = 'SET_STOCK_INFORMATION_OPTION';
var SET_SELECTED_VARIANT_IDENTIFIER = exports.SET_SELECTED_VARIANT_IDENTIFIER = 'SET_SELECTED_VARIANT_IDENTIFIER';
var SET_CALCULATION_ENABLED = exports.SET_CALCULATION_ENABLED = 'SET_CALCULATION_ENABLED';
var SET_CALCULATION_ERRORS_RESOLVED = exports.SET_CALCULATION_ERRORS_RESOLVED = 'SET_CALCULATION_ERRORS_RESOLVED';
var SET_CALCULATION_AUTO_RESOLVE_ENABLED = exports.SET_CALCULATION_AUTO_RESOLVE_ENABLED = 'SET_CALCULATION_AUTO_RESOLVE_ENABLED';
var SET_OPTIONCLASSIFICATION_CHECKED = exports.SET_OPTIONCLASSIFICATION_CHECKED = 'SET_OPTIONCLASSIFICATION_CHECKED';
var SET_CONFLICTING_SWITCHOPTION_DATA = exports.SET_CONFLICTING_SWITCHOPTION_DATA = 'SET_CONFLICTING_SWITCHOPTION_DATA';
var SET_SELECTED_AMOUNT = exports.SET_SELECTED_AMOUNT = 'SET_SELECTED_AMOUNT';
var SET_OPTION_INPUT_TEXT = exports.SET_OPTION_INPUT_TEXT = 'SET_OPTION_INPUT_TEXT';
var RESET_OPTION_INPUT_TEXTS = exports.RESET_OPTION_INPUT_TEXTS = 'RESET_OPTION_INPUT_TEXTS';
var SWITCH_SELECTED_AMOUNT = exports.SWITCH_SELECTED_AMOUNT = 'SWITCH_SELECTED_AMOUNT';
var SAVE_BULKNAMES = exports.SAVE_BULKNAMES = 'SAVE_BULKNAMES';
var CLEAR_BULKNAMES = exports.CLEAR_BULKNAMES = 'CLEAR_BULKNAMES';
var DELETE_SELECTED_AMOUNT = exports.DELETE_SELECTED_AMOUNT = 'DELETE_SELECTED_AMOUNT';
var SET_SELECTED_CALCULATION = exports.SET_SELECTED_CALCULATION = 'SET_SELECTED_CALCULATION';
var SET_COMMENT = exports.SET_COMMENT = 'SET_COMMENT';
var SET_SELECTED_AMOUNTS = exports.SET_SELECTED_AMOUNTS = 'SET_SELECTED_AMOUNTS';
var DELETE_SELECTED_AMOUNTS = exports.DELETE_SELECTED_AMOUNTS = 'DELETE_SELECTED_AMOUNTS';
var receiveConfiguration = exports.receiveConfiguration = function receiveConfiguration(json, _ref) {
  var checkValidation = _ref.checkValidation;
  return /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(dispatch, getState) {
      var prevState, action, _getState, configurator, configuration, selectedoptionclassification, loadIdentifier, _getAvailableConfigur, designerEnabled, initialDesignData;
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            prevState = getState();
            dispatch(setCalculationEnabled(false));
            if (checkValidation) {
              dispatch(inspectValidationResults(json));
            }
            action = dispatch({
              type: RECEIVE_CONFIGURATION,
              data: (0, _Modifiers.patchViewImages)(json),
              receivedAt: Date.now()
            });
            dispatch(inspectCheckResults());
            _getState = getState(), configurator = _getState.configurator;
            configuration = configurator.configuration, selectedoptionclassification = configurator.selectedoptionclassification, loadIdentifier = configurator.loadIdentifier;
            _getAvailableConfigur = (0, _Selectors2.getAvailableConfigurationModes)(getState()), designerEnabled = _getAvailableConfigur.designer;
            if (configurator.loadCode) {
              dispatch((0, _Actions4.addImagesFromDesignArea)(configurator));
            }
            dispatch(deleteMissingVariants(configurator));

            // load first optionclassification if not selected yet
            if (!selectedoptionclassification.identifier && (0, _configuration.getConf)('showInitialOptionclassification')) {
              dispatch(loadInitialOptionclassification(configuration));
            }
            if ((0, _configuration.getConf)('loadInspirations')) {
              dispatch(fetchInspirations(configuration.item.identifier));
            }
            dispatch((0, _Actions2.setVisible)('configurationvariantSelection', false));
            if (prevState.configurator.configuration.item.identifier && prevState.configurator.configuration.item.identifier !== configuration.item.identifier) {
              dispatch(fetchConfigurationVariants(configuration.item.identifier));
            }
            applyVariantAmountPreSelection(configurator);
            setDefaultSelectedVariantIdentifier((0, _Selectors.getConfigurator)(getState()), loadIdentifier);
            if (!designerEnabled) {
              _context.next = 24;
              break;
            }
            _context.next = 19;
            return dispatch((0, _Actions3.fetchFonts)());
          case 19:
            dispatch((0, _Actions5.addCustomFonts)((0, _Selectors3.getUsedCustomFontsInEditor)(getState())));
            _context.next = 22;
            return dispatch(loadDesignerData((0, _Selectors.getConfiguration)((0, _Selectors.getConfigurator)(getState()))));
          case 22:
            initialDesignData = (0, _Transformers.createInitialDesignDataFromDesignAreas)((0, _get["default"])(getState(), 'designArea.filteredDesignAreas') || [], (0, _Reducer.getDesignData)((0, _Selectors.getConfigurator)(getState())));
            dispatch((0, _Actions6.setInitialDesignData)(initialDesignData));
          case 24:
            // enable calculation and trigger it
            dispatch(setCalculationEnabled(true));
            dispatch(invalidateCalculation());
            dispatch(doCalculation((0, _Selectors.getConfiguration)((0, _Selectors.getConfigurator)(getState()))));
            return _context.abrupt("return", action);
          case 28:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }));
    return function (_x, _x2) {
      return _ref2.apply(this, arguments);
    };
  }();
};
var deleteMissingVariants = exports.deleteMissingVariants = function deleteMissingVariants(configurator) {
  return /*#__PURE__*/function () {
    var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2(dispatch) {
      var children, selectedAmounts, item, result, itemGroupChildren, _iterator, _step, itemGroup, flattenendSubChildren, selectedVariant;
      return _regeneratorRuntime().wrap(function _callee2$(_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            children = (0, _Selectors.getChildren)(configurator).map(function (variant) {
              return variant.identifier;
            });
            selectedAmounts = (0, _Selectors.getSelectedAmounts)(configurator);
            item = (0, _get["default"])(configurator, 'configuration.item');
            result = [];
            itemGroupChildren = (0, _get["default"])(item, 'itemGroup.children', []);
            if (itemGroupChildren.length > 0) {
              _iterator = _createForOfIteratorHelper(item.itemGroup.children);
              try {
                for (_iterator.s(); !(_step = _iterator.n()).done;) {
                  itemGroup = _step.value;
                  result.push(Object.values((0, _Selectors.getDeepestChildIdentifiers)(itemGroup)));
                }
              } catch (err) {
                _iterator.e(err);
              } finally {
                _iterator.f();
              }
            } else {
              result.push(item.identifier);
            }
            flattenendSubChildren = (0, _flatten["default"])(result);
            _context2.t0 = _regeneratorRuntime().keys(selectedAmounts);
          case 8:
            if ((_context2.t1 = _context2.t0()).done) {
              _context2.next = 15;
              break;
            }
            selectedVariant = _context2.t1.value;
            if (selectedAmounts.hasOwnProperty(selectedVariant)) {
              _context2.next = 12;
              break;
            }
            return _context2.abrupt("continue", 8);
          case 12:
            if (children.length !== 0 && children.indexOf(selectedVariant) === -1 && flattenendSubChildren.indexOf(selectedVariant) === -1) {
              dispatch(deleteSelectedAmount(selectedVariant));
              dispatch((0, _Actions2.reportError)((0, _i18n.t)('missingVariantError', {
                selectedVariant: selectedVariant
              })));
            }
            _context2.next = 8;
            break;
          case 15:
          case "end":
            return _context2.stop();
        }
      }, _callee2);
    }));
    return function (_x3) {
      return _ref3.apply(this, arguments);
    };
  }();
};
var setDefaultSelectedVariantIdentifier = exports.setDefaultSelectedVariantIdentifier = function setDefaultSelectedVariantIdentifier(configurator, loadIdentifier) {
  var variantChildren = (0, _Selectors.getChildren)(configurator).map(function (variant) {
    return variant.itemGroup ? variant.itemGroup.children : variant;
  });
  var children = (0, _uniq["default"])((0, _flatten["default"])(variantChildren).map(function (child) {
    return child.identifier;
  }));
  var firstSelectedAmountEntry = (0, _first["default"])(Object.keys((0, _Selectors.getSelectedAmounts)(configurator)));
  var item = (0, _Selectors.getItem)(configurator);
  var selectedVariant = children.length ? children[0] : null;
  if (children.indexOf(loadIdentifier) !== -1) {
    selectedVariant = loadIdentifier;
  } else if (firstSelectedAmountEntry) {
    selectedVariant = firstSelectedAmountEntry;
  } else {
    selectedVariant = item.identifier;
  }
  _ServiceLocator.Services.configurator.setSelectedVariantIdentifier(selectedVariant);
};
var applyVariantAmountPreSelection = exports.applyVariantAmountPreSelection = function applyVariantAmountPreSelection(configurator) {
  var designerPreSelection = (0, _configuration.getConf)('designerPreSelection', {});
  var itemAmounts = designerPreSelection.itemAmounts;
  if (itemAmounts) {
    var children = (0, _Selectors.getChildren)(configurator).map(function (variant) {
      return variant.identifier;
    });
    for (var preSelectionVariant in itemAmounts) {
      if (!itemAmounts.hasOwnProperty(preSelectionVariant)) {
        continue;
      }
      var amount = +itemAmounts[preSelectionVariant];
      if (children.indexOf(preSelectionVariant) !== -1 && amount > 0) {
        _ServiceLocator.Services.configurator.setSelectedAmount(preSelectionVariant, amount);
      }
    }
  }
};
var selectOptionclassification = exports.selectOptionclassification = function selectOptionclassification(optionclassification) {
  var triggerFetchOptions = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  var showOptionlist = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
  return function (dispatch, getState) {
    if (getState().ui.visibilityMap.startHere) {
      dispatch((0, _Actions2.setVisible)('startHere', false));
    }
    var action = dispatch({
      type: SELECT_OPTIONCLASSIFICATION,
      optionclassification: optionclassification
    });
    var configuration = getState().configurator.configuration;
    if (triggerFetchOptions) {
      _ServiceLocator.Services.analytics.triggerEvent(_Constant.EventTypes['select_component'], optionclassification.identifier);
      _ServiceLocator.Services.configurator.loadOptions(configuration.item.identifier, optionclassification.identifier, configuration);
    }
    dispatch((0, _Actions2.setVisible)('optionlist', showOptionlist));
    return action;
  };
};
var receiveOptions = exports.receiveOptions = function receiveOptions(json, extraData) {
  return function (dispatch, getState) {
    // it should wait until the options are loaded for the optionclassification...
    var optionclassification = extraData.optionclassification;

    // make sure the received option list belongs to the selected optionclassification,
    // it might have changed since the request was sent
    if (optionclassification === getState().configurator.selectedoptionclassification.identifier) {
      if ((0, _configuration.getConf)('checkOptionclassificationOnSelect')) {
        dispatch(setOptionclassificationChecked(optionclassification));
      }
      return dispatch({
        type: RECEIVE_OPTIONS,
        data: json,
        receivedAt: Date.now()
      });
    }
  };
};
var receiveSwitchoptionsresult = exports.receiveSwitchoptionsresult = function receiveSwitchoptionsresult(json, extraData) {
  return function (dispatch, getState) {
    var switchOptionData = extraData.switchOptionData,
      noCheck = extraData.noCheck,
      setChecked = extraData.setChecked,
      refreshOptions = extraData.refreshOptions;
    var action = dispatch({
      type: RECEIVE_SWITCHOPTIONSRESULT,
      data: (0, _Modifiers.patchViewImages)(json),
      receivedAt: Date.now()
    });
    var _getState2 = getState(),
      configurator = _getState2.configurator;
    var configuration = configurator.configuration,
      selectedoptionclassification = configurator.selectedoptionclassification;

    // if it was sent with noCheck param, there is nothing to do with the check results..
    // it should be a temporary configuration state
    if (noCheck) {
      return action;
    }
    var checkResultOk = dispatch(inspectCheckResults());
    if (checkResultOk) {
      if (setChecked) {
        dispatch(setOptionclassificationChecked((0, _first["default"])(Object.keys(switchOptionData))));
      }
      // do it only when there is a selected option classification
      if (refreshOptions && selectedoptionclassification) {
        _ServiceLocator.Services.configurator.loadOptions(configuration.item.identifier, selectedoptionclassification.identifier, configuration);
      }
    } else {
      dispatch(setConflictingSwitchoptionData(switchOptionData));
    }
    return action;
  };
};
var receiveCalculation = exports.receiveCalculation = function receiveCalculation(json) {
  return {
    type: RECEIVE_CALCULATION,
    data: json,
    receivedAt: Date.now()
  };
};
var invalidateCalculation = exports.invalidateCalculation = function invalidateCalculation() {
  return {
    type: INVALIDATE_CALCULATION
  };
};
var setCalculationErrorsResolved = exports.setCalculationErrorsResolved = function setCalculationErrorsResolved() {
  return {
    type: SET_CALCULATION_ERRORS_RESOLVED
  };
};
var setCalculationAutoResolveEnabled = exports.setCalculationAutoResolveEnabled = function setCalculationAutoResolveEnabled(enabled) {
  return {
    type: SET_CALCULATION_AUTO_RESOLVE_ENABLED,
    enabled: enabled
  };
};
var skipNextAutoResolve = exports.skipNextAutoResolve = function skipNextAutoResolve() {
  return setCalculationAutoResolveEnabled('skipNext');
};
var receiveOptionDetails = exports.receiveOptionDetails = function receiveOptionDetails(json) {
  return function (dispatch) {
    dispatch((0, _Actions2.setVisible)('optionDetails', true));
    return dispatch({
      type: RECEIVE_OPTIONDETAILS,
      data: json,
      receivedAt: Date.now()
    });
  };
};
var clearOptionDetails = exports.clearOptionDetails = function clearOptionDetails() {
  return {
    type: RECEIVE_OPTIONDETAILS,
    data: {},
    receivedAt: Date.now()
  };
};
var receiveSavedConfiguration = exports.receiveSavedConfiguration = function receiveSavedConfiguration(json) {
  return {
    type: RECEIVE_SAVEDCONFIGURATION,
    data: (0, _Modifiers.patchViewImages)(json),
    receivedAt: Date.now()
  };
};
var receiveValidation = exports.receiveValidation = function receiveValidation(json) {
  return function (dispatch, getState) {
    var action = dispatch({
      type: RECEIVE_VALIDATION,
      data: json,
      receivedAt: Date.now()
    });
    var validationResult = getState().configurator.validation;
    if ((0, _isObject["default"])(validationResult) && validationResult.success === false) {
      dispatch((0, _Actions2.setVisible)('validationResult', true));
      throw 'Invalid configuration!';
    }
    return action;
  };
};
var receiveConfigurationVariants = exports.receiveConfigurationVariants = function receiveConfigurationVariants(json) {
  return {
    type: RECEIVE_CONFIGURATIONVARIANTS,
    data: json,
    receivedAt: Date.now()
  };
};
var receiveCodesnippets = exports.receiveCodesnippets = function receiveCodesnippets(json) {
  return {
    type: RECEIVE_CODESNIPPETS,
    data: json,
    receivedAt: Date.now()
  };
};
var fetchConfigurationForDesignerProductPreview = exports.fetchConfigurationForDesignerProductPreview = function fetchConfigurationForDesignerProductPreview() {
  return /*#__PURE__*/function () {
    var _ref4 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee3(dispatch, getState) {
      var itemIdentifier, _getAvailableConfigur2, designerEnabled, initialDesignData;
      return _regeneratorRuntime().wrap(function _callee3$(_context3) {
        while (1) switch (_context3.prev = _context3.next) {
          case 0:
            itemIdentifier = getState().configurator.loadIdentifier;
            dispatch(setCalculationEnabled(false));
            _context3.next = 4;
            return dispatch(apiActions.fetchData('configuration/loadbyitemidentifier/' + itemIdentifier, function (json) {
              return {
                type: RECEIVE_CONFIGURATION,
                data: (0, _Modifiers.patchViewImages)(json),
                receivedAt: Date.now()
              };
            }));
          case 4:
            setDefaultSelectedVariantIdentifier((0, _Selectors.getConfigurator)(getState()), itemIdentifier);
            _getAvailableConfigur2 = (0, _Selectors2.getAvailableConfigurationModes)(getState()), designerEnabled = _getAvailableConfigur2.designer;
            if (!designerEnabled) {
              _context3.next = 12;
              break;
            }
            dispatch((0, _Actions7.selectConfigurationMode)('designer'));
            _context3.next = 10;
            return dispatch(loadDesignerData((0, _Selectors.getConfiguration)((0, _Selectors.getConfigurator)(getState()))));
          case 10:
            initialDesignData = (0, _Transformers.createInitialDesignDataFromDesignAreas)((0, _get["default"])(getState(), 'designArea.filteredDesignAreas') || [], (0, _Reducer.getDesignData)((0, _Selectors.getConfigurator)(getState())));
            dispatch((0, _Actions6.setInitialDesignData)(initialDesignData));
          case 12:
          case "end":
            return _context3.stop();
        }
      }, _callee3);
    }));
    return function (_x4, _x5) {
      return _ref4.apply(this, arguments);
    };
  }();
};
var receiveClientData = exports.receiveClientData = function receiveClientData(json) {
  return function (dispatch, getState) {
    dispatch({
      type: RECEIVE_CLIENT_DATA,
      data: json,
      receivedAt: Date.now()
    });
    if (json.success === false) {
      return dispatch((0, _Actions2.reportError)((0, _i18n.t)('clientValidationError')));
    }
    var client = (0, _Selectors.getClient)(getState().configurator);
    _Api["default"].setChannel(client.channel);
    var requests = [];
    if ((0, _Selectors.isDesignerProductPreviewMode)()) {
      // initial configuration is not needed
    } else {
      requests.push(_ServiceLocator.Services.configurator.loadInitialConfiguration());
    }
    requests.push(_ServiceLocator.Services.configurator.loadCodeSnippets());
    return Promise.all(requests);
  };
};
var receiveInspirations = exports.receiveInspirations = function receiveInspirations(json) {
  return {
    type: RECEIVE_INSPIRATIONS,
    data: json
  };
};
var setCustomTitle = exports.setCustomTitle = function setCustomTitle(title) {
  return {
    type: SET_CUSTOM_TITLE,
    title: title
  };
};
var inspectCheckResults = exports.inspectCheckResults = function inspectCheckResults() {
  return function (dispatch, getState) {
    var _getState3 = getState(),
      ui = _getState3.ui,
      configurator = _getState3.configurator;
    var configuration = configurator.configuration;
    if ((0, _isObject["default"])(configuration.check_results)) {
      if (configuration.check_results.status) {
        if (ui.visibilityMap.incompatibility) {
          dispatch((0, _Actions2.setVisible)('incompatibility', false));
        }
        return true;
      } else {
        dispatch((0, _Actions2.setVisible)('incompatibility', true));
        return false;
      }
    }
    return true;
  };
};
var inspectValidationResults = exports.inspectValidationResults = function inspectValidationResults(configuration) {
  return function (dispatch) {
    var validationResult = (0, _get["default"])(configuration, 'information.validation_result');
    if ((0, _isObject["default"])(validationResult) && validationResult.success === false) {
      dispatch((0, _Actions2.setVisible)('validationResult', true));
    }
  };
};
var fetchConfiguration = exports.fetchConfiguration = function fetchConfiguration(itemidentifier) {
  var selectOptions = (0, _configuration.getConf)('selectOptions');
  var urlToCall = "configuration/loadbyitemidentifier/".concat(itemidentifier);
  if (selectOptions) {
    var switchOptionData = JSON.stringify(getSwitchOptionData(selectOptions));
    urlToCall = "".concat(urlToCall, "?_switch_options=").concat(switchOptionData);
  }
  return apiActions.fetchData(urlToCall, receiveConfiguration);
};
var fetchConfigurationByCode = exports.fetchConfigurationByCode = function fetchConfigurationByCode(code) {
  var checkValidation = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
  return apiActions.fetchData('configuration/loadbyconfigurationcode/' + code, receiveConfiguration, {
    checkValidation: checkValidation
  });
};
var fetchConfigurationByCodeAsync = exports.fetchConfigurationByCodeAsync = function fetchConfigurationByCodeAsync(code) {
  var checkValidation = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
  return apiActions.fetchDataAsync('configuration/loadbyconfigurationcode/' + code, receiveConfiguration, {
    checkValidation: checkValidation
  });
};
var fetchOptions = exports.fetchOptions = function fetchOptions(itemidentifier, optionclassification, configuration) {
  return apiActions.postData('options/list/' + itemidentifier + '/' + optionclassification, {
    configuration: configuration
  }, receiveOptions, {},
  // config
  {
    optionclassification: optionclassification
  } // extraData
  );
};

var switchOptionsBasic = exports.switchOptionsBasic = function switchOptionsBasic(configuration, switchedOptions) {
  var noCheck = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
  var config = {};
  if (noCheck) {
    config.params = {
      nocheck: 1
    };
  }
  return apiActions.postData('configuration/switchoption', {
    configuration: configuration,
    switchedOptions: switchedOptions
  }, function (data) {
    return {
      // dummy receiver
      type: 'RECEIVE_SWITCHOPTIONSRESULT_BASIC',
      data: data
    };
  }, config);
};
var switchOptions = exports.switchOptions = function switchOptions(configuration, switchOptionData) {
  var noCheck = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
  var refreshOptions = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
  var setChecked = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : false;
  return function (dispatch) {
    return dispatch(switchOptionsBasic(configuration, switchOptionData, noCheck)).then(function (action) {
      var extraData = {
        switchOptionData: switchOptionData,
        noCheck: noCheck,
        refreshOptions: refreshOptions,
        setChecked: setChecked
      };
      return dispatch(receiveSwitchoptionsresult(action.data, extraData));
    });
  };
};
var doCalculation = exports.doCalculation = function doCalculation() {
  return function (dispatch, getState) {
    var configuration = (0, _Selectors.getConfiguration)((0, _Selectors.getConfigurator)(getState()));
    if (!configuration.item.identifier) {
      return {};
    }
    return dispatch(apiActions.postDataAsync('calculation', configuration, receiveCalculation));
  };
};
var fetchOptionDetails = exports.fetchOptionDetails = function fetchOptionDetails(optionidentifier, configuration) {
  return apiActions.postData('options/detail/' + optionidentifier, {
    configuration: configuration
  }, receiveOptionDetails);
};
var saveConfiguration = exports.saveConfiguration = function saveConfiguration(configuration, configurationtype) {
  return apiActions.postDataAsync('configurations', {
    configuration: configuration,
    configurationtype: configurationtype
  }, receiveSavedConfiguration);
};
var validateConfiguration = exports.validateConfiguration = function validateConfiguration(configuration) {
  return apiActions.postData('configuration/validate', {
    configuration: configuration
  }, receiveValidation);
};
var fetchConfigurationVariants = exports.fetchConfigurationVariants = function fetchConfigurationVariants(itemidentifier) {
  return apiActions.fetchData('items/getconfigurationvariants/' + itemidentifier, receiveConfigurationVariants);
};
var fetchCodesnippets = exports.fetchCodesnippets = function fetchCodesnippets() {
  return apiActions.fetchData('codesnippets/getcurrent', receiveCodesnippets);
};
var fetchClientData = exports.fetchClientData = function fetchClientData() {
  return apiActions.fetchData('client', receiveClientData);
};
var fetchInspirations = exports.fetchInspirations = function fetchInspirations(itemidentifier) {
  return apiActions.fetchData('inspirations/' + itemidentifier, receiveInspirations);
};
var setLoadCode = exports.setLoadCode = function setLoadCode() {
  var loadCode = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
  return {
    type: SET_LOAD_CODE,
    loadCode: loadCode
  };
};
var setLoadIdentifier = exports.setLoadIdentifier = function setLoadIdentifier(loadIdentifier) {
  return {
    type: SET_LOAD_IDENTIFIER,
    loadIdentifier: loadIdentifier
  };
};
var setStockInformationOption = exports.setStockInformationOption = function setStockInformationOption(option) {
  return {
    type: SET_STOCK_INFORMATION_OPTION,
    stockInformationOption: option
  };
};
var setSelectedVariantIdentifier = exports.setSelectedVariantIdentifier = function setSelectedVariantIdentifier(identifier) {
  return {
    type: SET_SELECTED_VARIANT_IDENTIFIER,
    selectedVariantIdentifier: identifier
  };
};
var setCalculationEnabled = exports.setCalculationEnabled = function setCalculationEnabled(enabled) {
  return {
    type: SET_CALCULATION_ENABLED,
    enabled: enabled
  };
};
var setOptionclassificationChecked = exports.setOptionclassificationChecked = function setOptionclassificationChecked(optionclassification) {
  return function (dispatch, getState) {
    if (_typeof(optionclassification) !== 'object') {
      optionclassification = (0, _find["default"])(getState().configurator.configuration.optionclassifications, {
        identifier: optionclassification
      });
    }
    if (!getState().configurator.checkedOptionclassifications[optionclassification.identifier]) {
      return dispatch({
        type: SET_OPTIONCLASSIFICATION_CHECKED,
        optionclassification: optionclassification
      });
    }
  };
};
var setConflictingSwitchoptionData = exports.setConflictingSwitchoptionData = function setConflictingSwitchoptionData(switchOptionData) {
  return {
    type: SET_CONFLICTING_SWITCHOPTION_DATA,
    switchOptionData: switchOptionData
  };
};
var fetchInitialConfiguration = exports.fetchInitialConfiguration = function fetchInitialConfiguration() {
  return function (dispatch, getState) {
    var _getState$configurato = getState().configurator,
      loadCode = _getState$configurato.loadCode,
      loadIdentifier = _getState$configurato.loadIdentifier;
    var defaultLoadIdentifier = (0, _configuration.getConf)('defaultLoadIdentifier');
    if (loadCode) {
      // Load the configuration by code
      return dispatch(fetchConfigurationByCode(loadCode)).then(function (configuration) {
        if (configuration.error) {
          dispatch((0, _Actions2.reportConfigurationNotFoundError)((0, _i18n.t)('loadConfiguration.error.loadingFailed')));
        } else {
          _ServiceLocator.Services.analytics.triggerEvent(_Constant.EventTypes.load_item, configuration.data.item.identifier);
        }
      });
    } else if ((0, _configuration.getConf)('loadVariantsFirst')) {
      // Load variants by identifier
      dispatch((0, _Actions2.setVisible)('configurationvariantSelection', true));
      return dispatch(fetchConfigurationVariants(loadIdentifier)).then(function (result) {
        // if the result contains error just return, do nothing else
        if (result.error) {
          return;
        }
        var _getState$configurato2 = getState().configurator,
          configurationvariants = _getState$configurato2.configurationvariants,
          loadIdentifier = _getState$configurato2.loadIdentifier;

        // If there is only one variant or the list is empty, fall back to fetchConfiguration
        if ((0, _isArray["default"])(configurationvariants)) {
          if (configurationvariants.length === 0) {
            // Load the options for the initially selected optionclassification
            dispatch(fetchConfiguration(loadIdentifier));
          }
          if (configurationvariants.length === 1) {
            // There is only one variant in the list, just load it
            dispatch(fetchConfiguration(configurationvariants[0].identifier));
          }
        }
      });
    } else if (loadIdentifier === '__empty__') {
      return Promise.resolve();
    } else if (loadIdentifier) {
      return dispatch(fetchConfiguration(loadIdentifier));
    } else if (defaultLoadIdentifier) {
      return dispatch(fetchConfiguration(defaultLoadIdentifier));
    }
  };
};
var loadInitialOptionclassification = exports.loadInitialOptionclassification = function loadInitialOptionclassification(configuration) {
  return function (dispatch) {
    var identifier = configuration.item.identifier;
    var optionclassification = (0, _get["default"])(configuration, 'optionclassifications[0]');
    dispatch(selectOptionclassification(optionclassification));
    _ServiceLocator.Services.configurator.loadOptions(identifier, optionclassification.identifier, configuration);
    dispatch((0, _Actions2.setVisible)('optionlist', true));
  };
};
var resolveConflicts = exports.resolveConflicts = function resolveConflicts() {
  return function (dispatch, getState) {
    var _getState4 = getState(),
      configurator = _getState4.configurator;
    var configuration = configurator.configuration;
    var incompatibilityCheckResults = configuration.check_results;
    var p = false;
    if ((0, _isArray["default"])(incompatibilityCheckResults.check_results)) {
      dispatch(setCalculationEnabled(false)); // disable calculation while waiting for all options to be switched
      var _iterator2 = _createForOfIteratorHelper(incompatibilityCheckResults.check_results),
        _step2;
      try {
        var _loop = function _loop() {
          var result = _step2.value;
          if (result.status === false) {
            // check for data to perform automated option switching
            var switchOptionsData = (0, _get["default"])(result, 'data.switchOptions');
            if (switchOptionsData) {
              if (p) {
                p = p.then(function (action) {
                  return dispatch(switchOptionsBasic(action.data, switchOptionsData, true));
                });
              } else {
                p = dispatch(switchOptionsBasic(configuration, switchOptionsData, true));
              }
            }
          }
        };
        for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
          _loop();
        }
      } catch (err) {
        _iterator2.e(err);
      } finally {
        _iterator2.f();
      }
      if (p) {
        p = p.then(function (action) {
          // after all conflicts resolved, the desired option can be set
          var conflictingSwitchOptionData = getState().configurator.conflictingSwitchOptionData;
          return dispatch(switchOptions(action.data, conflictingSwitchOptionData, false, true, true));
        }).then(function (action) {
          if ((0, _get["default"])(action, 'data.check_results.status') === false) {
            throw 'There are new conflicts..';
          }
          var configuration = getState().configurator.configuration;

          // enable calculation and refresh it
          dispatch(setCalculationEnabled(true));
          dispatch(invalidateCalculation());
          dispatch(doCalculation(configuration));

          // hide the incompatibility dialog
          dispatch((0, _Actions2.setVisible)('incompatibility', false));
          return action;
        })["catch"](function (e) {
          // eslint-disable-next-line no-console
          console.warn('Problem when resolving conflicts:', e);
        });
      } else {
        dispatch((0, _Actions2.setVisible)('incompatibility', false));
        dispatch(setCalculationEnabled(true));
      }
    }
    return p;
  };
};
var selectOption = exports.selectOption = function selectOption(option) {
  var refreshOptionlist = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
  var showOptionDetails = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
  var optionclassification = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
  return function (dispatch, getState) {
    var _getState$configurato3 = getState().configurator,
      configuration = _getState$configurato3.configuration,
      selectedoptionclassification = _getState$configurato3.selectedoptionclassification;
    if (!optionclassification) {
      optionclassification = selectedoptionclassification;
    }
    _ServiceLocator.Services.analytics.triggerEvent(_Constant.EventTypes['switch_option'], {
      component: optionclassification.identifier,
      option: option.identifier
    });
    var switchOptionData = _defineProperty({}, optionclassification.identifier, _objectSpread(_objectSpread({}, option), {}, {
      amount: isNaN(parseInt(option.amount)) ? 0 : option.amount,
      check_results: null // it can mess the response, so should remove it.
    }));

    dispatch((0, _Actions2.setVisible)('optionDetails', showOptionDetails));
    return dispatch(switchOptions(configuration, switchOptionData, false, refreshOptionlist, true));
  };
};
var applyOptionInputText = exports.applyOptionInputText = function applyOptionInputText(optionClassification) {
  return function (dispatch, getState) {
    var switchOptionData = _defineProperty({}, optionClassification.identifier, []);
    var _getState$configurato4 = getState().configurator,
      configuration = _getState$configurato4.configuration,
      optionInputTexts = _getState$configurato4.optionInputTexts;
    if (!optionClassification.selectedoptions) {
      return;
    }
    var _iterator3 = _createForOfIteratorHelper(optionClassification.selectedoptions),
      _step3;
    try {
      for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
        var selectedOption = _step3.value;
        var inputText = (0, _get["default"])((0, _find["default"])(optionInputTexts, ['optionIdentifier', selectedOption.identifier]), 'inputText', null);
        if (inputText && inputText !== selectedOption.inputText) {
          switchOptionData[optionClassification.identifier].push(_objectSpread(_objectSpread({}, selectedOption), {}, {
            inputText: inputText,
            check_results: null
          }));
        }
      }
    } catch (err) {
      _iterator3.e(err);
    } finally {
      _iterator3.f();
    }
    dispatch(resetOptionInputTexts());
    if (switchOptionData[optionClassification.identifier].length > 0) {
      return dispatch(switchOptions(configuration, switchOptionData, false, true, true));
    }
  };
};
var selectMultipleOptions = exports.selectMultipleOptions = function selectMultipleOptions(optionsList) {
  return function (dispatch, getState) {
    var configuration = (0, _Selectors.getConfiguration)((0, _Selectors.getConfigurator)(getState()));
    var switchOptionData = getSwitchOptionData(optionsList);
    return dispatch(switchOptions(configuration, switchOptionData, false, false, true));
  };
};
var getSwitchOptionData = function getSwitchOptionData(optionsList) {
  var switchOptionData = {};
  var _iterator4 = _createForOfIteratorHelper(optionsList),
    _step4;
  try {
    for (_iterator4.s(); !(_step4 = _iterator4.n()).done;) {
      var component = _step4.value;
      switchOptionData[component.identifier] = component.selectedoptions.map(function (_ref5) {
        var identifier = _ref5.identifier,
          amount = _ref5.amount;
        return {
          identifier: identifier,
          amount: typeof amount === 'undefined' ? 1 : amount,
          check_results: null
        };
      });
    }
  } catch (err) {
    _iterator4.e(err);
  } finally {
    _iterator4.f();
  }
  return switchOptionData;
};
var viewOptionDetails = exports.viewOptionDetails = function viewOptionDetails(option) {
  return function (dispatch, getState) {
    if (!option) {
      return;
    }
    var _getState$configurato5 = getState().configurator,
      configuration = _getState$configurato5.configuration,
      optiondetails = _getState$configurato5.optiondetails;
    if (optiondetails.identifier !== option.identifier) {
      dispatch(fetchOptionDetails(option.identifier, configuration));
    } else {
      dispatch((0, _Actions2.setVisible)('optionDetails', true));
    }
  };
};
var loadConfiguration = exports.loadConfiguration = function loadConfiguration() {
  return /*#__PURE__*/function () {
    var _ref6 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee4(dispatch, getState) {
      var loadCode, action;
      return _regeneratorRuntime().wrap(function _callee4$(_context4) {
        while (1) switch (_context4.prev = _context4.next) {
          case 0:
            loadCode = getState().configurator.loadCode;
            if (loadCode) {
              _context4.next = 3;
              break;
            }
            throw new Error((0, _i18n.t)('loadConfiguration.error.emptyCode'));
          case 3:
            dispatch((0, _Actions2.dismissError)());
            dispatch((0, _Actions2.setWorkInProgress)('loadConfiguration', true));
            _context4.prev = 5;
            _context4.next = 8;
            return dispatch(fetchConfigurationByCodeAsync(loadCode));
          case 8:
            action = _context4.sent;
            dispatch((0, _Actions2.setVisible)('loadConfiguration', false));
            return _context4.abrupt("return", action);
          case 13:
            _context4.prev = 13;
            _context4.t0 = _context4["catch"](5);
            dispatch((0, _Actions2.dismissError)()); // ignore original REQUEST_ERROR, should be handled by the caller
            throw new Error((0, _i18n.t)('loadConfiguration.error.loadingFailed'));
          case 17:
            _context4.prev = 17;
            dispatch((0, _Actions2.setWorkInProgress)('loadConfiguration', false));
            return _context4.finish(17);
          case 20:
          case "end":
            return _context4.stop();
        }
      }, _callee4, null, [[5, 13, 17, 20]]);
    }));
    return function (_x6, _x7) {
      return _ref6.apply(this, arguments);
    };
  }();
};
var receiveDesignerData = exports.receiveDesignerData = function receiveDesignerData(data) {
  return (0, _createActionWithGlobalState.createActionWithGlobalState)({
    type: RECEIVE_DESIGNER_DATA,
    data: data,
    receivedAt: Date.now()
  });
};
var loadDesignerData = exports.loadDesignerData = function loadDesignerData(configuration) {
  return /*#__PURE__*/function () {
    var _ref7 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee5(dispatch) {
      return _regeneratorRuntime().wrap(function _callee5$(_context5) {
        while (1) switch (_context5.prev = _context5.next) {
          case 0:
            if (!(!configuration || !configuration.item || !configuration.item.identifier)) {
              _context5.next = 2;
              break;
            }
            return _context5.abrupt("return", dispatch((0, _Actions2.reportError)((0, _i18n.t)('loadConfigurationModes.error.missingItemIdentifier'))));
          case 2:
            dispatch((0, _Actions2.dismissError)());
            dispatch((0, _Actions2.setWorkInProgress)('loadConfigurationModes', true));
            _context5.prev = 4;
            _context5.next = 7;
            return dispatch(apiActions.postDataAsync('/configurationmodes/designer/getdata', {
              configuration: configuration
            }, receiveDesignerData));
          case 7:
            return _context5.abrupt("return", _context5.sent);
          case 10:
            _context5.prev = 10;
            _context5.t0 = _context5["catch"](4);
            return _context5.abrupt("return", dispatch((0, _Actions2.reportError)((0, _i18n.t)('loadConfigurationModes.error.loadingFailed'))));
          case 13:
            _context5.prev = 13;
            dispatch((0, _Actions2.setWorkInProgress)('loadConfigurationModes', false));
            return _context5.finish(13);
          case 16:
          case "end":
            return _context5.stop();
        }
      }, _callee5, null, [[4, 10, 13, 16]]);
    }));
    return function (_x8) {
      return _ref7.apply(this, arguments);
    };
  }();
};
var setSelectedAmount = exports.setSelectedAmount = function setSelectedAmount(identifier, amount) {
  var isUpdatedByUser = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
  return {
    type: SET_SELECTED_AMOUNT,
    identifier: identifier,
    amount: amount,
    isUpdatedByUser: isUpdatedByUser
  };
};
var saveBulkNames = exports.saveBulkNames = function saveBulkNames(identifier, bulkNamesData) {
  return {
    type: SAVE_BULKNAMES,
    identifier: identifier,
    bulkNamesData: bulkNamesData
  };
};
var clearBulkNames = exports.clearBulkNames = function clearBulkNames() {
  return {
    type: CLEAR_BULKNAMES
  };
};
var deleteSelectedAmount = exports.deleteSelectedAmount = function deleteSelectedAmount(identifier) {
  return {
    type: DELETE_SELECTED_AMOUNT,
    identifier: identifier
  };
};
var setSelectedAmounts = exports.setSelectedAmounts = function setSelectedAmounts(variant, sizes, isUpdatedByUser) {
  return {
    type: SET_SELECTED_AMOUNTS,
    variant: variant,
    sizes: sizes,
    isUpdatedByUser: isUpdatedByUser
  };
};
var deleteSelectedAmounts = exports.deleteSelectedAmounts = function deleteSelectedAmounts(variant, sizes) {
  return {
    type: DELETE_SELECTED_AMOUNTS,
    variant: variant,
    sizes: sizes
  };
};
var setComment = exports.setComment = function setComment(comment) {
  return {
    type: SET_COMMENT,
    comment: comment
  };
};
var switchSelectedAmount = exports.switchSelectedAmount = function switchSelectedAmount(srcIdentifier, dstIdentifier) {
  return {
    type: SWITCH_SELECTED_AMOUNT,
    srcIdentifier: srcIdentifier,
    dstIdentifier: dstIdentifier
  };
};
var setSelectedCalculation = exports.setSelectedCalculation = function setSelectedCalculation(identifier, value) {
  return {
    type: SET_SELECTED_CALCULATION,
    identifier: identifier,
    value: value
  };
};
var setOptionInputText = exports.setOptionInputText = function setOptionInputText(identifier, value) {
  return {
    type: SET_OPTION_INPUT_TEXT,
    identifier: identifier,
    value: value
  };
};
var resetOptionInputTexts = exports.resetOptionInputTexts = function resetOptionInputTexts() {
  return {
    type: RESET_OPTION_INPUT_TEXTS
  };
};